<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-7>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>{{ $t("dashboard.consentdetail") }}</h2>
          </v-flex>
        </v-layout>
        <div class="pa-9">
          <v-layout row wrap justify-center pt-5>
            <v-flex xs11 md12 lg12 pa-2>
              <v-card class="rounded-lg">
                <v-tabs v-model="tab" align-with-title color="#077893">
                  <v-tabs-slider color="#077893"></v-tabs-slider>
                  <v-tab v-for="(item, i) in items" :key="i">
                    {{ $t(item.text) }}
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                  <v-tab-item>
                    <GeneralConsent />
                  </v-tab-item>
                  <v-tab-item>
                    <GroupConsent />
                  </v-tab-item>
                </v-tabs-items>
              </v-card>
            </v-flex>
          </v-layout>
        </div>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from '@/components/layouts/LoadingPage.vue'
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import GeneralConsent from "../Dashboard/DashboardGeneralConsent.vue";
import GroupConsent from "../Dashboard/DashboardGroupConsent.vue";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { GeneralConsent, GroupConsent, OverlaySearch },
  data() {
    return {
      loadingDownloadData: false,
      info: "",
      Consentitems: [],
      tab: null,
      Logsend: [],
      GeneralConsent: [],
      GroupConsent: [],
      SourceSystem: [],
      series: [],
      LogSend: [],
      items: [
        { text: "consentlist.generalconsent" },
        {
          text: "consentlist.groupconsent",
        },
      ],
    };
  },
  methods: {},
  computed: {},
  mounted() {},
  created() {},
};
</script>

<style>
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

@media screen and (max-width: 1263px) {
  .flexresponsive {
    display: none !important;
  }
}
</style>
